<div class="search-form">
    <mat-form-field class="search-form" appearance="outline" >
        <mat-icon matIconPrefix>search</mat-icon>
        <input matInput  placeholder="{{'organizationSearchPlaceholder' | translate}}" name="searchTerm" [(ngModel)]="searchTerm" (input)="search(searchTerm)">
    </mat-form-field>
</div>
